import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { IconButton, Icon, Panel, Modal, CheckboxGroup, Checkbox, Message } from 'rsuite'
import { saveProjectPlan5Year } from '../../../redux/actions/objectiveGoal'
import { startLoading, doneLoading } from '../../../utils/loading'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import { getValueFromOptions } from '../../../utils/dataUtil'
import EditButton from '../../../components/buttons/editButton/EditButton'
import notification from '../../../utils/notification'
import { SAVE_SUCCESS_MSG } from '../../../constants/msgText'

export default function Plan5YearWidget({ schema: _schema, onSuccess = () => {}, ...props }) {
  const { showCommandButton } = props
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(_schema)
  const [plan5YearSelected, setPlan5YearSelected] = useState(_schema?.plan5Year?.value || [])
  const [isEditPlan, setIsEditPlan] = useState(false)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // console.log('ResultWidget _schema', _schema)
    setFormSchema(_schema)

    if (showCommandButton) {
      if (_schema?.plan5Year?.value.length == 0) {
        setIsEditPlan(true)
      }
    }
  }, [_schema])

  const handleUpdateSave = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let results = plan5YearSelected?.map((item) => {
        return {
          value: item,
        }
      })
      let request = {
        results: plan5YearSelected?.length > 0 ? results : [],
      }

      console.log('request', request)
      let response = await saveProjectPlan5Year(request, projectId)

      if (response) {
        setFormSchema(response)
        setPlan5YearSelected(response.plan5Year?.value)
        setIsEditPlan(false)
        setIsError(false)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(
        e?.response?.data?.errors?.Message || 'ไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
      )
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Panel shaded header={formSchema?.header || ' '} collapsible defaultExpanded>
        {isEditPlan ? (
          <>
            <CheckboxGroup
              name={formSchema.plan5Year?.name}
              value={plan5YearSelected || []}
              onChange={(value) => {
                console.log(value)
                setPlan5YearSelected(value)
              }}
            >
              {formSchema.plan5Year?.options?.map((item, index) => {
                return (
                  <Checkbox value={item.value} disabled={item.disabled} key={index}>
                    {item.label}
                  </Checkbox>
                )
              })}
            </CheckboxGroup>

            <br />

            {showCommandButton && (
              <>
                {isError && <Message showIcon type="error" description={isError} />}
                <SaveButton onClick={handleUpdateSave} disabled={isLoading}>
                  บันทึก
                </SaveButton>
                <CancelButton
                  onClick={() => {
                    setIsEditPlan(false)
                    setPlan5YearSelected(formSchema?.plan5Year?.value)
                  }}
                  disabled={isLoading}
                >
                  ยกเลิก
                </CancelButton>
              </>
            )}
          </>
        ) : (
          <>
            {plan5YearSelected?.map((item, index) => {
              return <p>&#9679; {getValueFromOptions(formSchema.plan5Year?.options, item)}</p>
            })}

            <br />
            {showCommandButton && (
              <>
                <EditButton
                  onClick={() => {
                    setIsEditPlan(true)
                  }}
                  disabled={isLoading}
                >
                  แก้ไข
                </EditButton>
              </>
            )}
          </>
        )}

        <br />
      </Panel>
    </>
  )
}
